import debug from 'debug';
import { redirect } from 'redux-first-router';
import { beginTask, endTask } from 'redux-nprogress';

import * as types from './users.types';
import { ERASE_PREVIOUS_DATA } from '../../app/views/AccountInfo/module/accountInfo';
import { RENEW_SUBSCRIPTION_VIEW } from '../../app/views/PaymentInformation/module';

const log = debug('huddle:store:actions:users');

export const getUser = async (dispatch, getState, { api }) => {
  dispatch(beginTask());

  log('Retrieving users');
  dispatch({ type: types.USER_GET_REQUEST });

  try {
    const { users } = await api.user.getUserInfo();

    return dispatch({
      type: types.USER_GET_SUCCESS,
      payload: { users },
    });
  } catch (error) {
    log('Error from call to api.user.getUserInfo:\n %O', error);
    return dispatch({
      type: types.USER_GET_ERROR,
      error,
    });
  } finally {
    dispatch(endTask());
  }
};

// using this to attach id to the response, which the API doesn't do
const putHelper = async (api, id, user) => {
  const { users } = await api.user.putUser(id, user);
  return ({ id, users });
};

export const createUser = toCreate => async (dispatch, getState, { api }) => {
  dispatch(beginTask());

  log('Creating user:\n %O', toCreate);
  dispatch({ type: types.USER_CREATE_REQUEST });

  try {
    const { users } = await api.user.postUser(toCreate);

    return dispatch({
      type: types.USER_CREATE_SUCCESS,
      payload: { users },
    });
  } catch (error) {
    log('Error from call to api.user.postUser:\n %O', error);
    return dispatch({
      type: types.USER_CREATE_ERROR,
      error,
    });
  } finally {
    dispatch(endTask());
  }
};

export const updateUser = toUpdate => async (dispatch, getState, { api }) => {
  dispatch(beginTask());
  log('Updating user:\n %O', toUpdate);
  dispatch({ type: types.USER_UPDATE_REQUEST });
  try {
    const { users } = await putHelper(api, toUpdate.id, toUpdate);
    // Display Success message
    document.getElementById('successMessage').setAttribute('style', 'display: flex');
    setTimeout(() => document.getElementById('successMessage').setAttribute('style', 'display: none'), 5000);
    window.scrollTo(0, 0);

    dispatch({
      type: types.USER_UPDATE_SUCCESS,
      payload: { users },
    });

    dispatch({
      type: ERASE_PREVIOUS_DATA,
    });

  } catch (error) {
    log('Error from call to api.user.putUser:\n %O', error);
    // Display Error message
    document.getElementById('errorMessage').setAttribute('style', 'display: flex');
    setTimeout(() => document.getElementById('errorMessage').setAttribute('style', 'display: none'), 5000);
    window.scrollTo(0, 0);

    // Display previous password message
    if (error.message === 'Invalid password') {
      alert('Please correct the following issues with your account:\nYour previous password does not match what we have in our records, please check your password and try again.');
    }

    dispatch({
      type: types.USER_UPDATE_ERROR,
      error,
    });
  } finally {
    dispatch(endTask());
  }
};

export const deleteUser = toDelete => async (dispatch, getState, { api }) => {
  dispatch(beginTask());

  log('Deleting user:\n %O', toDelete);
  dispatch({ type: types.USER_DELETE_REQUEST });

  try {
    const { users } = await api.user.deleteUser(toDelete);

    return dispatch({
      type: types.USER_DELETE_SUCCESS,
      payload: { users },
    });
  } catch (error) {
    log('Error from call to api.user.deleteUser:\n %O', error);
    return dispatch({
      type: types.USER_DELETE_ERROR,
      error,
    });
  } finally {
    dispatch(endTask());
  }
};

// Helper method to make checking subscription status easier for redirect
export const checkSubscriptionStatus = (dispatch, getState) => {
  const { accountInfo = {} } = getState();

  const IS_ACTIVE_STATUS = 'A';
  const subAccountInfo = accountInfo.accountInfo || {};
  if (typeof subAccountInfo.status !== "undefined") {
    if (subAccountInfo.status !== IS_ACTIVE_STATUS) {
      dispatch(redirect({ type: RENEW_SUBSCRIPTION_VIEW }));
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/users.actions.js